import * as React   from "react"
import PropTypes    from "prop-types"
import HotTable     from "react-handsontable"
import Handsontable from "handsontable"

const PROP_NAMES = { LABEL: "label" }

export default class InvestmentTable extends React.Component {

	render() {
		const years    = this.props.years
		const lastYear = _.last(years)
		const settings = {
			cells     : function(row, col, prop) {
				// getting source data of the row
				const rowData   = this.instance.getSourceDataAtRow(row)
				// creating cell properties
				const cellProps = {
					renderer: function(instance, TD, row, col, prop2, value, cellProperties) {
						if ("label" !== prop) { // if prop is not label (ex.: 2013, 2012, etc.)
							// applying the numeric renderer
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
						} else {
							// applying the text renderer
							Handsontable.renderers.TextRenderer.apply(this, arguments)
						}

						// setting styles depending of rowData
						if (rowData && rowData.isTitle) {
							TD.style.fontWeight = "bold"
						} else if (rowData && rowData.isDetail) {
							TD.style.fontStyle = "italic"
							TD.style.fontSize  = "0.8em"
							TD.style.textAlign = "right"
						}
					}
				}

				if (rowData && !rowData.isCurrency) cellProps.format = "0,0"

				return cellProps
			},
			colHeaders: _.concat([""], years, "Total"),
			columns   : [
				{ data: PROP_NAMES.LABEL },
				...this._getYearColumns(years),
				{ data: "total", format: "0,0.00 $", language: "fr-FR", type: "numeric" }
			],
			data      : this.props.data,
			fixedColumnsLeft: 1,
			readOnly  : true,
			stretchH  : "all"
		}

		return <HotTable settings={settings} />
	}

	_getYearColumns = (years) => {
		const columns   = []
		const firstYear = years[0]

		for (let i = firstYear; i < firstYear + years.length; i++) {
			columns.push({ data: i.toString(), format: "0,0.00 $", language: "fr-FR", type: "numeric" })
		}

		return columns
	}
}

InvestmentTable.propTypes = {
	data : PropTypes.array.isRequired,
	years: PropTypes.arrayOf(PropTypes.number)
}


// WEBPACK FOOTER //
// ./src/component/ratios/investment/investment-table/index.js